import { render, staticRenderFns } from "./DropdownText.vue?vue&type=template&id=16438455"
import script from "./DropdownText.vue?vue&type=script&lang=js"
export * from "./DropdownText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports